"use client";

// §8.213 — root error boundary (also covers root-layout render errors,
// which error.tsx cannot). Reports to Sentry (no-op without a DSN) and
// shows a JP recovery surface instead of a white screen — the second
// half of the pre-launch audit's missing-boundaries finding (§8.211
// covered not-found). Must render its own <html>/<body>: when this
// boundary fires, the root layout may be the thing that crashed.

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="ja">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#F6F7F9",
          color: "#0B1220",
          fontFamily:
            '-apple-system,BlinkMacSystemFont,"Hiragino Sans","Hiragino Kaku Gothic ProN","Yu Gothic UI","Yu Gothic",Meiryo,"Noto Sans CJK JP",system-ui,sans-serif',
        }}
      >
        <div style={{ maxWidth: 420, padding: "0 24px", textAlign: "center" }}>
          <h1
            style={{
              margin: 0,
              fontSize: 22,
              fontWeight: 700,
              letterSpacing: "-0.02em",
            }}
          >
            問題が発生しました
          </h1>
          <p
            style={{
              margin: "12px 0 0",
              fontSize: 14,
              lineHeight: 1.7,
              color: "#64748B",
            }}
          >
            一時的なエラーの可能性があります。再読み込みしても解決しない場合は、時間をおいてもう一度お試しください。
          </p>
          {error.digest ? (
            <p style={{ margin: "10px 0 0", fontSize: 11, color: "#94A3B8" }}>
              エラーコード: {error.digest}
            </p>
          ) : null}
          <button
            type="button"
            onClick={() => reset()}
            style={{
              marginTop: 24,
              height: 46,
              padding: "0 22px",
              borderRadius: 11,
              border: "none",
              background: "#2563EB",
              color: "#fff",
              fontSize: 14,
              fontWeight: 700,
              cursor: "pointer",
              fontFamily: "inherit",
            }}
          >
            再読み込み
          </button>
        </div>
      </body>
    </html>
  );
}
